module.exports = __webpack_public_path__ + "img/详情@2x.74ff9b10.png";